import Vue from "vue";
import { Mutation } from "../types";

export default {
  [Mutation.GET_DEVICE](state, device) {
    let index = state.devices.findIndex((h) => h.hash === device.hash);

    let currentDevice = {};
    if (index !== -1) {
      currentDevice = state.devices[index];
    } else {
      index = 0;
    }

    currentDevice.title = device.title;
    currentDevice.serial = device.hublot;
    currentDevice.nextUpdate = device.nextUpdate;
    currentDevice.maxSettings = device.max_settings;
    currentDevice.currentSettings = device.current_settings;
    currentDevice.deviceType = device.deviceType;
    currentDevice.cartridgeFill = device.cartridgeFill;
    currentDevice.connectionType = device.connectionType;
    currentDevice.online = device.online;
    currentDevice.error = device.error;
    currentDevice.wifiStrength = device.wifiStrength;
    currentDevice.cartridgeSize = device.cartridgeSize;

    if (device.scent) {
      currentDevice.background = device.scent.image;
      currentDevice.scent = device.scent.title;
    } else {
      currentDevice.background = "no-scent";
      currentDevice.scent = "No scent";
    }

    Vue.set(state.devices, index, currentDevice);
  },
  [Mutation.GET_DEVICES](state, result) {
    state.devices = [];
    if (result.length) {
      result.forEach(function (device, index) {
        let background = "no-scent";
        let scentTitle = "No cartridge";

        if (device.scent) {
          background = device.scent.image;
          scentTitle = device.scent.title;
          if (!device.cartridgeFill) {
            scentTitle = "Unknown cartridge";
          }
        }

        let deviceView = {
          key: device.id,
          title: device.title,
          scent: scentTitle,
          cartridgeFill: device.cartridgeFill,
          cartridgeSize: device.cartridgeSize,
          online: device.online,
          error: device.error,
          background: background,
          hash: device.hash,
          connectionType: device.connectionType,
          organisation: device.organisationName,
          wifiStrength: device.wifiStrength
        };

        Vue.set(state.devices, index, deviceView);
      });
    }
  },
};
